<mat-label>{{ label() }}</mat-label>

<input class="file-input" type="file" (change)="onFileSelected($event)" #fileUpload />

<div class="file-upload">
    @if (fileName(); as fileName) {
        <button mat-button color="primary" class="upload-btn" (click)="download.emit()">
            {{ fileName }}
            <mat-icon svgIcon="save-outlined"></mat-icon>
        </button>
        <button mat-icon-button class="delete-btn" (click)="delete.emit()">
            <mat-icon svgIcon="trash-can"></mat-icon>
        </button>
    } @else {
        <button mat-button color="primary" class="upload-btn" (click)="fileUpload.click()">
            {{ file ? file.name : "Choose file"  }}
            <mat-icon svgIcon="paperclip"></mat-icon>
        </button>
    }
</div>